import React, { Component } from 'react';
import PropTypes from 'prop-types'

import Card from 'components/Card'
import WidgetError from 'components/WidgetError'

import styles from './styles.module.scss'

class ServerVersions extends Component {

  render() {
    const { title, isLoading, connectionError } = this.props
    return (
      <Card title={title} isLoading={isLoading}>
        <div className={styles.widgetContainer}>
          { connectionError ? <WidgetError errTxt={connectionError}/> : this.renderWidget()}
        </div>
      </Card>
    )
  }

  renderWidget() {
    const { data } = this.props
    if (!data) return

    const { code = {}, data: versions = {} } = data[0]

    // Derive everything from the response so the table reshapes when the set of
    // servers or regions changes, with no code change required.
    const servers = Array.from(new Set([...Object.keys(code), ...Object.keys(versions)]))
    const regions = Array.from(
      new Set(servers.flatMap(server => Object.keys(versions[server] || {})))
    ).sort()

    return (
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Server</th>
            <th>Code</th>
            {regions.map(region => <th key={region}>{region.toUpperCase()}</th>)}
          </tr>
        </thead>
        <tbody>
          {servers.map(server => (
            <tr key={server}>
              <th scope="row">{this.capitalize(server)}</th>
              <td className={styles.code}>{code[server] || '—'}</td>
              {regions.map(region => (
                <td key={region}>{(versions[server] && versions[server][region]) || '—'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  }

}

ServerVersions.propTypes = {
  title: PropTypes.string.isRequired
}

export default ServerVersions;
